module.exports = "/ui/main/images/bdayIcon.png?388b81631e5e82e93a7c585c3216eb13";